import React from 'react';
import { useTranslation } from 'react-i18next';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';
import { useSlideData } from '@context/slide-data';
import { ClientPortalStyle } from './styles';

export const ClientPortal = () => {
    const { t } = useTranslation();
    const slideKey = 'client_portal';
    const { desktop } = useSlideData();
    return (
        <ClientPortalStyle desktop={desktop}>
          <div>
            <img id='slide-model' src={generateSlideImageUrl('client_portal.png')} alt='slide-model' />
          </div>
          <div className="bullets">
            <label>{t(`${slideKey}.bullet_categories.manage.title`)}</label>
            <ul>
                <li>{t(`${slideKey}.bullet_categories.manage.bullet_1`)}</li>
                <li>{t(`${slideKey}.bullet_categories.manage.bullet_2`)}</li>
                <li>{t(`${slideKey}.bullet_categories.manage.bullet_3`)}</li>
                <li>{t(`${slideKey}.bullet_categories.manage.bullet_4`)}</li>
            </ul>
            <label>{t(`${slideKey}.bullet_categories.client_services.title`)}</label>
            <ul>
                <li>{t(`${slideKey}.bullet_categories.client_services.bullet_1`)}</li>
                <li>{t(`${slideKey}.bullet_categories.client_services.bullet_2`)}</li>
            </ul>
            <label>{t(`${slideKey}.bullet_categories.learn.title`)}</label>
            <ul>
                <li>{t(`${slideKey}.bullet_categories.learn.bullet_1`)}</li>
                <li>{t(`${slideKey}.bullet_categories.learn.bullet_2`)}</li>
                <li>{t(`${slideKey}.bullet_categories.learn.bullet_3`)}</li>
            </ul>
          </div>
        </ClientPortalStyle>
    );
};

export default ClientPortal;
